module.exports = __webpack_public_path__ + "media/categories/1006-a9625499.svg";